import React from "react";
import LandingPageForm from "../LandingPageForm";
import airplaneCoins from "../../../../../img/landing-page/quiz/airplane-coins.png";

const LandingPageQuizForm = ({ submitted } = props) => {
	return (
		<div className="offers-landing-page-quiz-form">
			<img alt="" src={airplaneCoins} />
			<LandingPageForm
				gaEventLabel="Quiz"
				id="offers-landing-page-quiz-form"
				buttonColor="green"
				buttonText="DESCUBRA AGORA"
				submitted={() => submitted()}
			/>
		</div>
	);
};

export default LandingPageQuizForm;
